import BulletListIcon from './component'

export default BulletListIcon
